import axiosInstance from "../utils/axios-instance";

export const getPermissions = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/permissions`
  );
  return response.data;
};
